import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

import config from "@/lib/config";
import Cookies from "@/lib/cookies";
import debugLog from "@/lib/debugLog";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { SOAPDataSource } from "apollo-datasource-soap";
import { v4 as uuidv4 } from "uuid";
/**
 * @typedef {Object} RecommendResult
 * @property {string} elementId
 * @property {string} sessionId
 * @property {string} content
 */

/**
 * @type {Object} AbstractParamsAttributes
 * @property {string} accountId
 */

/**
 * @typedef {Object} AbstractParams
 * @property {AbstractParamsAttributes} attributes
 * @property {string} member - ユニークユーザーID
 * @property {string} ipAddress - IPアドレス
 * @property {string} location - アクセスしたページのURL
 * @property {string} userAgent - ユーザーエージェント
 */

/**
 * @type {string}
 */

var RTOASTER_API_URL = "https://rt.rtoaster.jp/api/engine?wsdl";
/**
 * Rtoasterとの通信クラス.
 *
 * @constructor
 */

var _abstractParams = /*#__PURE__*/new WeakSet();

var Rtoaster = /*#__PURE__*/function (_SOAPDataSource) {
  _inherits(Rtoaster, _SOAPDataSource);

  var _super = _createSuper(Rtoaster);

  function Rtoaster(options) {
    var _this;

    _classCallCheck(this, Rtoaster);

    _this = _super.call(this, RTOASTER_API_URL);

    /**
     * get abstractParams.
     * @returns {AbstractParams}
     */
    _classPrivateMethodInitSpec(_assertThisInitialized(_this), _abstractParams);

    _this.context = options;
    return _this;
  }
  /**
   * track.
   *
   * @param {string} location
   * @param {string} referrer
   * @param {object} options
   * @returns {Promise<void>}
   */


  _createClass(Rtoaster, [{
    key: "track",
    value: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(location, referrer) {
        var _this2 = this;

        var options,
            params,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;

                params = function () {
                  var params = _classPrivateMethodGet(_this2, _abstractParams, _abstractParams2).call(_this2, location);

                  if (referrer) {
                    params.referrer = referrer;
                  }

                  if (options) {
                    var list = Object.keys(options).map(function (key) {
                      return {
                        attributes: {
                          name: key
                        },
                        $value: options[key]
                      };
                    });
                    params.appKey = list;
                  }

                  return params;
                }();

                debugLog("rtoaster track", JSON.stringify(params, null, 2));
                _context.next = 5;
                return this.invoke("track", {
                  data: params
                });

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function track(_x, _x2) {
        return _track.apply(this, arguments);
      }

      return track;
    }()
    /**
     * recommend.
     *
     * @param {string} location
     * @param {string[]} elementId
     * @returns {Promise<RecommendResult[]>}
     */

  }, {
    key: "recommend",
    value: function () {
      var _recommend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(location, elementId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.invoke("recommend", {
                  query: _objectSpread(_objectSpread({}, _classPrivateMethodGet(this, _abstractParams, _abstractParams2).call(this, location)), {
                    elementId: elementId
                  })
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function recommend(_x3, _x4) {
        return _recommend.apply(this, arguments);
      }

      return recommend;
    }()
  }]);

  return Rtoaster;
}(SOAPDataSource);

function _abstractParams2(location) {
  var _req$deviceInfo;

  var _this$context = this.context,
      req = _this$context.req,
      res = _this$context.res;

  var member = function () {
    if (req.userToken) {
      var _req$userToken;

      return (_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.hashedUserId;
    } else {
      // uuidv4
      // cookieから読む、なければ生成して保存
      var cookies = new Cookies(req, res);
      var rtid = cookies.get(config.rtoaster.uuidCookieName);

      if (rtid) {
        return rtid;
      } else {
        var uuid = uuidv4();
        cookies.set({
          name: config.rtoaster.uuidCookieName,
          value: uuid
        });
        return uuid;
      }
    }
  }();

  var ipAddress = getRemoteIpAddress(req);
  var userAgent = req === null || req === void 0 ? void 0 : (_req$deviceInfo = req.deviceInfo) === null || _req$deviceInfo === void 0 ? void 0 : _req$deviceInfo.ua;
  return {
    attributes: {
      accountId: config.rtoaster.accountId
    },
    member: member,
    ipAddress: ipAddress,
    userAgent: userAgent,
    location: location
  };
}

export default Rtoaster;